"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Authenticated = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var events = _interopRequireWildcard(require("../../constants/events"));
var _tokens = require("../../utils/tokens");
var _hooks = require("../../hooks");
var Authenticated = function Authenticated(props) {
  var children = props.children; // pull the authManager from AuthContext

  var authManager = (0, _hooks.useAuthManager)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    shouldRender = _useState2[0],
    setShouldRender = _useState2[1];
  var onStateChange = function onStateChange() {
    if (authManager !== null) {
      setShouldRender((0, _tokens.isTokensValid)(authManager.getTokens()));
    }
  };
  (0, _react.useEffect)(function () {
    if (authManager !== null) {
      // on mount we run authenticate
      authManager.authenticate().then(function () {
        onStateChange();
        authManager.on(events.USER_FOUND, onStateChange);
        authManager.on(events.LOAD_USER_ERROR, onStateChange);
        authManager.on(events.USER_SIGNED_OUT, onStateChange);
        authManager.on(events.SESSION_TERMINATED, onStateChange);
      }).catch(function () {
        onStateChange();
      }); // on unmount, we remove our listeners

      return function () {
        authManager.removeListener(events.USER_FOUND, onStateChange);
        authManager.removeListener(events.LOAD_USER_ERROR, onStateChange);
        authManager.removeListener(events.USER_SIGNED_OUT, onStateChange);
        authManager.removeListener(events.SESSION_TERMINATED, onStateChange);
      };
    }
  }, []);
  return shouldRender ? children : null;
};
exports.Authenticated = Authenticated;
Authenticated.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)])
};
Authenticated.defaultProps = {
  children: null
};
var _default = Authenticated;
exports.default = _default;